// Curated objective ideas shown to managers when they add an objective to a
// debrief. Static on purpose: it is inspiration, not company data. Strings are
// French (primary locale) and go through t() where they are rendered.
export const OBJECTIVE_LIBRARY = [
  {
    id: "welcome",
    label: "Accueil et relation client",
    objectives: [
      {
        name: "Soigner l'accueil au début de l'appel",
        hint: "Se présenter, nommer l'entreprise et sourire dans la voix dès les premières secondes.",
      },
      {
        name: "Personnaliser l'échange",
        hint: "Utiliser le nom du client et rappeler le contexte de sa demande.",
      },
      {
        name: "Conclure chaleureusement",
        hint: "Remercier, vérifier qu'il ne manque rien et souhaiter une bonne journée.",
      },
    ],
  },
  {
    id: "listening",
    label: "Écoute et compréhension",
    objectives: [
      {
        name: "Écouter sans interrompre le client",
        hint: "Laisser le client terminer ses phrases avant de répondre.",
      },
      {
        name: "Reformuler la demande",
        hint: "Résumer le besoin du client pour s'assurer de l'avoir bien compris.",
      },
      {
        name: "Poser des questions ouvertes",
        hint: "Creuser le besoin réel avant de proposer une solution.",
      },
    ],
  },
  {
    id: "difficult",
    label: "Situations difficiles",
    objectives: [
      {
        name: "Désamorcer un client en colère",
        hint: "Reconnaître l'émotion, rester calme et proposer une issue concrète.",
      },
      {
        name: "Exprimer de l'empathie",
        hint: "Montrer que l'on comprend la situation avant de chercher la solution.",
      },
      {
        name: "Savoir dire non avec tact",
        hint: "Refuser une demande en expliquant pourquoi et en proposant une alternative.",
      },
    ],
  },
  {
    id: "efficiency",
    label: "Efficacité",
    objectives: [
      {
        name: "Résoudre la demande dès le premier appel",
        hint: "Éviter que le client doive rappeler pour le même sujet.",
      },
      {
        name: "Maîtriser la durée des appels",
        hint: "Rester efficace sans donner l'impression de presser le client.",
      },
      {
        name: "Limiter les temps d'attente",
        hint: "Prévenir le client avant une mise en attente et ne pas le laisser trop longtemps.",
      },
    ],
  },
  {
    id: "sales",
    label: "Vente et conseil",
    objectives: [
      {
        name: "Proposer systématiquement une offre complémentaire",
        hint: "Identifier le bon moment pour suggérer un produit ou un service adapté.",
      },
      {
        name: "Répondre aux objections",
        hint: "Traiter les freins du client plutôt que de les contourner.",
      },
      {
        name: "Conclure la vente",
        hint: "Proposer clairement la prochaine étape et obtenir l'engagement du client.",
      },
    ],
  },
  {
    id: "rigor",
    label: "Rigueur et suivi",
    objectives: [
      {
        name: "Respecter les mentions et consignes obligatoires",
        hint: "Énoncer les informations légales et suivre le script quand il est exigé.",
      },
      {
        name: "Renseigner la fiche client après l'appel",
        hint: "Laisser un compte rendu clair pour que tout collègue puisse reprendre le dossier.",
      },
      {
        name: "Tenir les engagements pris auprès du client",
        hint: "Rappeler, relancer ou transmettre dans les délais annoncés.",
      },
    ],
  },
];
